import * as R from "ramda";
import classnames from "classnames";
import { connect } from "react-redux";
import React, { useEffect, useState, Fragment } from "react";
import { Button, Divider, Icon, message, Modal, Select } from "antd";

import { isFunction } from "@/util";
import {
  addTagApi,
  projectMediaSourcesOrdersTagsList,
} from "../aliyun-service-api";
import { Prompt } from "./create-project";
import { SortableList } from "@/components/SortableList/SortableList";

export const useTagList = (orderId, refreshKey = 0) => {
  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    if (!orderId) return;
    projectMediaSourcesOrdersTagsList(orderId).then((res) => {
      const tags = R.defaultTo([], R.pathOr([], ["tags"], res));
      const tags_detail = R.defaultTo([], R.pathOr([], ["tags_detail"], res));

      const tagList = R.map((tag) => {
        const currentTagCount = R.find(R.propEq(tag.id, "tag_id"), tags);
        return {
          ...tag,
          ...currentTagCount,
        };
      })(tags_detail);
      setTagList(tagList);
    });
  }, [orderId, refreshKey]);

  return tagList;
};

// noinspection JSUnusedGlobalSymbols
export const TagManager = (props) => {
  const [tagList, setTagList] = useState([]);

  const tags = R.pathOr([], ["tags"], props);
  const setTags = R.pathOr(R.T, ["setTags"], props);
  const setAvailableTags = R.pathOr(R.T, ["setAvailableTags"], props);

  const firstTag = R.pathOr(undefined, [0])(tags);

  const orderId = R.pathOr(0, ["match", "params", "orderid"], props) * 1;
  const userId = R.pathOr("0", ["user", "id"], props) * 1;

  const [tagRefreshKey, setTagRefreshKey] = useState(0);

  const list = useTagList(orderId, tagRefreshKey);

  useEffect(() => {
    setTagList(list);
    setAvailableTags(list);
  }, [list]);

  return (
    <Fragment>
      <div className="flex-y-center">
        <span className="mr10">标签:</span>
        <div className="flex-y-center children-space-x-4">
          {tagList.map((currentTagItem) => (
            <span
              key={currentTagItem.id}
              className={classnames({
                "link-not-active": firstTag !== currentTagItem.id,
                "link-active": firstTag === currentTagItem.id,
              })}
              onClick={() => {
                if (tags.includes(currentTagItem.id)) {
                  setTags([]);
                } else {
                  setTags([currentTagItem.id]);
                }
              }}
            >
              {currentTagItem.name}({R.defaultTo(0, currentTagItem.count)})
            </span>
          ))}
        </div>
        <div className="ml-auto">
          <Button
            onClick={async () => {
              Prompt({
                title: "新建标签",
                placeholder: "请输入标签名称",
              }).then((tagName) => {
                addTagApi(orderId, tagName, userId).then(() => {
                  message.success("新建成功");
                  setTagRefreshKey(R.inc);
                });
              });
            }}
            type="link"
            icon="plus"
            className="mr10"
          >
            新建
          </Button>
          {/*<ResourceTagModal>
            {({ open }) => (
              <Button type="link" icon="setting" onClick={open}>
                管理
              </Button>
            )}
          </ResourceTagModal>*/}
        </div>
      </div>
    </Fragment>
  );
};

// noinspection JSUnusedGlobalSymbols
export const ResourceTagModal = (props) => {
  const [visible, setVisible] = useState(false);
  const [tags, setTags] = useState([]);
  const { children } = props;

  useEffect(() => {
    if (!visible) return;

    // fetch tags
    setTimeout(() => {
      setTags([
        { id: 1, name: "标签1" },
        { id: 2, name: "标签2" },
        { id: 3, name: "标签3" },
      ]);
    }, 1000);
  }, [visible]);

  const open = () => {
    setVisible(true);
  };

  const close = () => {
    setVisible(false);
  };

  const handleSortEnd = (newTags) => {
    setTags(newTags);
  };

  return (
    <Fragment>
      <Modal
        title="资源标签管理"
        visible={visible}
        onCancel={close}
        onOk={close}
        width={640}
      >
        <div className="color-gray mb-4">拖拽标签可调整顺序</div>
        <SortableList items={tags} onSortEnd={handleSortEnd} />
      </Modal>
      {isFunction(children) ? children({ open }) : children}
    </Fragment>
  );
};

export const TagSelect = connect((state) => ({
  ...state,
}))((props) => {
  const tagList = R.pathOr([], ["tagList"], props);
  const refreshTagList = R.pathOr(R.T, ["refreshTagList"], props);
  const orderId = R.pathOr(0, ["orderId"], props) * 1;
  const userId = R.pathOr("", ["user", "id"], props) * 1;
  return (
    <Select
      {...props}
      dropdownRender={(menu) => (
        <div>
          {menu}
          <Divider className="hidden" style={{ margin: "4px 0" }} />
          <div
            className="hidden"
            style={{ padding: "4px 8px", cursor: "pointer" }}
            onMouseDown={(e) => e.preventDefault()}
            onClick={async () => {
              Prompt({
                title: "新建标签",
                placeholder: "请输入标签名称",
              }).then((tagName) => {
                addTagApi(orderId, tagName, userId).then(() => {
                  message.success("新建成功");
                  refreshTagList();
                });
              });
            }}
          >
            <Icon type="plus" /> 添加标签
          </div>
        </div>
      )}
    >
      {tagList.map((tag) => (
        <Select.Option key={tag.id} value={tag.id}>
          {tag.name}
        </Select.Option>
      ))}
    </Select>
  );
});



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/resource-tag-modal.js